export const getImageBase64 = (element) => {
    return new Promise((resolve, reject) => {

        if (!window.File || !window.FileReader || !window.FileList || !window.Blob) {
            console.error("Error: seems File API is not supported on your browser");
            return;
        }
        if (!element.files || !element.files[0]) return;

        const reader = new FileReader();
        reader.readAsDataURL(element.files[0]);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}